/**
 * Строка задачи в каталоге.
 *
 * Значок статуса всегда сопровождается текстом (`решено`, `есть попытки`):
 * значок и цвет не должны быть единственным способом узнать состояние
 * (docs/10-ui-ux.md, доступность).
 */

import { Link } from 'react-router'

import type { TaskListItem } from '@/api/catalog'
import { strings } from '@/lib/strings'

import { statusView } from './taskStatus'

export function TaskRow({ task }: { task: TaskListItem }) {
  const status = statusView(task.progress)

  return (
    <li className="flex flex-wrap items-center gap-x-3 gap-y-1 px-3 py-2 text-sm">
      <span className="flex items-center gap-1.5">
        <span aria-hidden="true" className={status.className}>
          {status.icon}
        </span>
        <span className="sr-only">{status.label}</span>
      </span>

      <Link to={`/tasks/${task.slug}`} className="font-medium hover:underline">
        {task.title}
      </Link>

      <span className="text-xs text-muted">{strings.catalog.difficulty[task.difficulty]}</span>

      <span className="flex flex-wrap gap-1">
        {task.tags.map((tag) => (
          <span key={tag} className="rounded border border-border px-1.5 py-0.5 text-xs text-muted">
            {tag}
          </span>
        ))}
      </span>

      <span className="ml-auto text-xs text-muted">
        {task.progress !== null && task.progress.status !== 'solved'
          ? strings.catalog.attempts(task.progress.attempts_count)
          : status.status === 'not-started'
            ? ''
            : status.label}
      </span>
    </li>
  )
}
